import clsx from "clsx";
import { OrderSummary } from "@app/types";
import { formatMoneyVN } from "@app/utils/util";
import { useT } from "@app/contexts/preferences.context";

/** 4 ô thống kê trên đầu bảng, lấy từ GET /orders/summary. Chưa tải xong thì hiện "—". */
function OrderStats({ summary }: { summary?: OrderSummary }) {
  const t = useT();

  return (
    <div className="grid grid-cols-4 gap-2.5 max-[760px]:grid-cols-2">
      {(
        [
          ["Tổng đơn", summary?.total, ""],
          ["Đang hoạt động", summary?.active, "text-ok"],
          ["Đã kết thúc", summary?.ended, ""],
          ["Tổng chi", summary ? `${formatMoneyVN(summary.spent)}đ` : undefined, ""],
        ] as [string, number | string | undefined, string][]
      ).map(([label, value, color]) => (
        <div key={label} className="flex flex-col gap-0.5 rounded-card border border-line bg-surface px-4 py-3">
          <span className="text-[12.5px] text-muted">{t(label)}</span>
          <b className={clsx("text-xl tabular-nums", color)}>{value ?? "—"}</b>
        </div>
      ))}
    </div>
  );
}

export default OrderStats;
